import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = `${config.backendUrl}/managerProjectRequested/operation`;

export const acceptOperationAction = createAsyncThunk(
  "operationAction/accept",
  async ({ projectid, userid }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${BackendURL}/accept`,
        { projectid, userid },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Failed to accept operation"
      );
    }
  }
);

export const rejectOperationAction = createAsyncThunk(
  "operationAction/reject",
  async ({ projectid, userid }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${BackendURL}/reject`,
        { projectid, userid },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "Failed to reject operation"
      );
    }
  }
);

const operationActionSlice = createSlice({
  name: "operationAction",
  initialState: {
    loading: false,
    success: false,
    error: null,
    message: null,
  },
  reducers: {
    resetOperationActionState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder

    .addCase(acceptOperationAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(acceptOperationAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
      })
      .addCase(acceptOperationAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(rejectOperationAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(rejectOperationAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
      })
      .addCase(rejectOperationAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetOperationActionState } = operationActionSlice.actions;
export default operationActionSlice.reducer;
